import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <dees-hint></dees-hint>
`;
